import React from 'react';

export const AboutArchivedSimple: React.FC = () => {
  return (
    <div className="space-y-8">
      <div className="text-center space-y-4 pt-6 pb-8">
        <h1 className="text-4xl font-display font-normal text-charcoal-900 mb-4">
          Archived Home Page
        </h1>
        <p className="text-charcoal-600">
          This is the archived version of the home page that was replaced with the new Elevation design.
        </p>
      </div>

      {/* Original simple home page content */}
      <div className="min-h-screen flex items-center justify-center bg-charcoal-50 p-12">
        <h1 className="text-6xl font-display font-normal text-charcoal-900">
          Elevation
        </h1>
      </div>
    </div>
  );
};









